module.exports = __webpack_public_path__ + "static/media/survey.9e11a3a0.svg";